import { Link } from "react-router-dom";
import Layout from "../../components/Layout/Layout";

const About = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          A project of Earthbound Martian
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">About Lunamalies</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Lunamalies is a public archive of lunar anomalies — especially Transient
          Lunar Phenomena (TLP). The name is Luna + anomalies.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Why this exists</h2>
        <p className="leading-relaxed mb-4">
          Historical TLP reports are real observational records: colored glows,
          mists, brightenings, and darkenings noted by astronomers from the 16th
          century onward. They usually get folded into general UAP collections,
          where the lunar context is easy to lose.
        </p>
        <p className="leading-relaxed">
          Lunamalies keeps them in one place that is queryable, cited, and drawn
          on a Moon map. The tone is archival, not sensational. We record what
          observers reported and where they said they saw it. We do not promote
          an explanation.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Sources in v1</h2>
        <p className="leading-relaxed mb-4">
          The first catalog is{" "}
          <a
            className="text-turquoise hover:text-mars"
            href="https://ntrs.nasa.gov/citations/19680018720"
            target="_blank"
            rel="noreferrer"
          >
            Middlehurst, Burley, Moore, and Welther 1968, NASA Technical Report
            R-277
          </a>
          , <em>Chronological Catalog of Reported Lunar Events</em> (~576 reports,
          1540–1967). That report is a U.S. government publication.
        </p>
        <p className="leading-relaxed">
          Next ingest: Cameron 1978 (NASA TM-79399, ~1,468 events) and the 2006
          extension, then NELIOTA impact flashes and ALPO/BAA reports.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">How locations work</h2>
        <p className="leading-relaxed mb-4">
          Catalogs name features more often than they give coordinates. We match
          location text to IAU named features and store selenographic latitude
          and longitude (east-positive). Reports that only say “dark side” or
          “whole moon” stay unlocated.
        </p>
        <p className="leading-relaxed">
          Phenomenon types follow Winifred Cameron’s five classes (gaseous,
          reddish, blue/green/violet, brightening, darkening). For TR R-277 those
          labels are inferred from the description. Cameron’s own catalogs will
          carry her classifications when they are ingested.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Earthbound Martian</h2>
        <p className="leading-relaxed mb-6">
          Lunamalies is built by Earthbound Martian as a tool for the stargazing
          and remote-travel community. If you observe from dark skies, the
          Landships are for that kind of work.
        </p>
        <div className="flex flex-wrap gap-3">
          <a
            href="https://earthboundmartian.com"
            className="inline-block bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
          >
            Visit Earthbound Martian
          </a>
          <Link
            to="/contact"
            className="inline-block border border-alt-blk px-8 py-4 rounded-2xl font-semibold hover:bg-alt-blk hover:text-white transition-colors"
          >
            Contact
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default About;
